import { createStore } from 'redux'
import rootReducer from './reducers'

// redux store setup with redex_dev chrome ex (2nd arg needs to be removed in pr)
const store = createStore(rootReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())

export default store